import React, { useCallback } from 'react';

import {
  DOWNLOAD_MATERIALS_SET_QUERY,
  DownloadMaterialsSetQueryResponse
} from '../../../queries/downloadMaterialsSet.query';

import { MaterialsSetUUID } from '../../../materialsSetsTypes';
import { ClassName } from '../../../../../types';

import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';
import { useDownloadMaterialsSet } from '../../../../materialsSets/hooks/useDownloadMaterialsSet';
import { useDownloadNanoId } from '../../../../downloads/hooks/useDownloadNanoId';

import { PureButtonHelper } from '../../../../../helpers/buttons/PureButtonHelper';

import { DownloadCache } from '../../../../downloads/DownloadCache';

import { words } from '../../../../../locales/keys';

interface DownloadMaterialsSetButtonProps {
  className?: ClassName;
  materialsSetUuid: MaterialsSetUUID;
}

function DownloadMaterialsSetButton({
  className,
  materialsSetUuid
}: DownloadMaterialsSetButtonProps) {
  const { downloadNanoId } = useDownloadNanoId();

  const {
    downloadMaterialsSet,
    downloadMaterialsSetErrorMessage,
    downloadMaterialsSetLoading
  } = useDownloadMaterialsSet<DownloadMaterialsSetQueryResponse>({
    query: DOWNLOAD_MATERIALS_SET_QUERY,
    cacheKeys: [DownloadCache.indexCacheKey()]
  });

  useShowToastOnErrorChange({ error: downloadMaterialsSetErrorMessage });

  const handleDownloadMaterialsSet = useCallback<() => void>(
    () =>
      downloadMaterialsSet({
        uuid: materialsSetUuid,
        deviceNanoId: downloadNanoId
      }),
    [materialsSetUuid, downloadNanoId, downloadMaterialsSet]
  );

  return (
    <PureButtonHelper
      className={
        className ||
        'flex text-left dark:hover:bg-gray-800 hover:bg-gray-100 px-4 py-2 text-sm w-full whitespace-nowrap'
      }
      dataGa="selected-materials-set-download-button"
      i18nText={words.download}
      disabled={downloadMaterialsSetLoading}
      onClick={handleDownloadMaterialsSet}
    />
  );
}

export default DownloadMaterialsSetButton;
